interface RoleBadgeProps {
  role: "human_lead" | "human_partner";
}

export function RoleBadge({ role }: RoleBadgeProps) {
  const isLead = role === "human_lead";

  return (
    <span
      style={{
        display: "inline-block",
        padding: "2px 8px",
        fontSize: 11,
        fontWeight: 500,
        borderRadius: 4,
        background: isLead ? "var(--accent)" : "var(--surface3)",
        color: isLead ? "white" : "var(--text2)",
      }}
    >
      {isLead ? "Lead" : "Partner"}
    </span>
  );
}
